import { useState } from "react";
import { Button, CircularProgress, InputLabel, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog";
import { storeBulk } from "../services/api";
import { useMutation } from "react-query";

export default function AddBulk({ open, close, menu, subcategory, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [disableTextArea, setDisableTextArea] = useState(false)
  const [schemaProducts, setSchemaProducts] = useState([])

  const mutation = useMutation(storeBulk, {
    onSuccess: (data) => {
      setIsLoading(false)
      setDisableTextArea(false)
      if (data.status === "error") {
        reportAction(false, 'Error al guardar los datos', 'error')
      } else { reportAction(true, 'Acción realizada correctamente', 'success') }
    }
  })

  const handleAdd = () => {
    const data = schemaProducts.filter((item) => item.name !== null && item.name !== undefined && item.name !== "")
    console.log(data)
    setDisableTextArea(true)
    setIsLoading(true)
    //setTimeout(() => { setIsLoading(false) }, 2000)
    mutation.mutate({ id: subcategory, params: { products: data } })
  }

  const handleClose = () => { setSchemaProducts([]); close() }

  const handleChangeProductsTextarea = (event) => {
    setSchemaProducts([])
    if (event.target.value !== null && event.target.value !== undefined && event.target.value !== "") {
      event.target.value.split('\n').forEach((product) => {
        setSchemaProducts((prev) => [...prev, { name: product, active: true }])
      })
    }
  }

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t('button_text_cancel')}</Button>
      <Button variant="contained" color="info" onClick={() => handleAdd()}>{t('button_text_add')}</Button>
    </> : <CircularProgress />}
  </>)

  return (
    <FlexibleWidthDialog maxWidth="sm" open={open} title={t('builder_bulkload_dialog_title')} actions={<Actions />}>
      <>
        <Typography sx={{ mb: 2, fontWeight: "bold" }}> {t('builder_bulkload_dialog_description_products')} </Typography>
        <InputLabel htmlFor="products_textarea" required style={{ fontSize: 14 }}>{t('builder_bulkload_dialog_label_products_textarea')}</InputLabel>
        <TextField fullWidth multiline margin="dense" size="medium" rows={5}
          id="products_textarea" name="products_textarea" disabled={disableTextArea}
          value={schemaProducts.map((category) => category.name).join('\n')}
          onChange={handleChangeProductsTextarea} />
      </>
    </FlexibleWidthDialog>
  )
}